import { Redirect, Route } from "react-router-dom";
import {
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import {
  gridOutline,
  receiptOutline,
  walletOutline,
  ellipsisHorizontalOutline,
} from "ionicons/icons";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import OtherMenuList from "../pages/other";
import Dashboard from "../pages/dashboard";
import Transaction from "../pages/transaction";
import Finance from "../pages/finance";
import Credit from "../pages/credit";
import Product from "../pages/product";
import Profile from "../pages/profile";
import NewTransaction from "./transaction/new-transaction";
import AddProduct from "./product/add-product";
import EditProduct from "./product/edit-product";
import EditTransaction from "./transaction/edit-transaction";
import DetailTransaction from "./transaction/detail-transaction";
import CashBank from "./finance/cash-bank";
import TransactionFinish from "./transaction/transaction-finish";

const PrivatePage: React.FC = () => (
      <IonTabs>
        <IonRouterOutlet>
          <Redirect exact path='/' to='/app/dashboard' />
          <Redirect exact path='/app' to='/app/dashboard' />
          
          <Route exact path="/app/dashboard" component={Dashboard} />

          {/* Transaction */}
          <Route exact path="/app/transaction" component={Transaction} />
          <Route exact path="/app/transaction/finish" component={TransactionFinish} />
          <Route exact path="/app/transaction/new" component={NewTransaction} />
          <Route exact path="/app/transaction/view/:id" component={DetailTransaction} />
          <Route exact path="/app/transaction/edit/:id" component={EditTransaction} />

          {/* Finance */}
          <Route exact path="/app/finance" component={Finance} />
          <Route exact path="/app/finance/account" component={CashBank} />


          {/* Other Menu */}
          <Route exact path="/app/other" component={OtherMenuList} />

          {/* Product */}
          <Route exact path="/app/product" component={Product} />
          <Route exact path="/app/product/add" component={AddProduct} />
          <Route path="/app/product/edit/:id" component={EditProduct} />

          <Route exact path="/app/profile" component={Profile} />

          <Route exact path="/app/credit" component={Credit} />
        </IonRouterOutlet>

        <IonTabBar slot="bottom">
          <IonTabButton tab="dashboard" href="/app/dashboard">
            <IonIcon icon={gridOutline} title="Dashboard" />
            <IonLabel>Dashboard</IonLabel>
          </IonTabButton>

          {/* Transaction */}
          <IonTabButton  tab="transaction" href="/app/transaction">
            <IonIcon icon={receiptOutline} title="Transaksi" />
            <IonLabel>Transaksi</IonLabel>
          </IonTabButton>

          <IonTabButton  tab="finance" href="/app/finance">
            <IonIcon icon={walletOutline} title="Keuangan" />
            <IonLabel>Keuangan</IonLabel>
          </IonTabButton>

          <IonTabButton tab="other" href="/app/other">
            <IonIcon icon={ellipsisHorizontalOutline} title="Lainnya" />
            <IonLabel>Lainnya</IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
);

export default PrivatePage;
